import { Button, ButtonProps } from '@mui/material'
import NextLink, { LinkProps as NextLinkProps } from 'next/link'
import { forwardRef } from 'react'

export interface InternalLinkButtonProps
  extends
    Omit<ButtonProps, 'href' | 'component' | 'onClick' | 'onMouseEnter' | 'onTouchStart'>,
    Omit<NextLinkProps, 'passHref' | 'legacyBehavior'> {}

interface ComposableNextLinkProps extends Omit<NextLinkProps, 'href'> {
  to: NextLinkProps['href']
}

// We have to rename href because MUI's Button component uses href as a prop, which conflicts with Next.js Link's href prop.
// We specifically use `to` to because MUI Button sets `role` to `button` if neither `to` nor `href` is provided
export const ComposableNextLink = forwardRef<HTMLAnchorElement, ComposableNextLinkProps>(function ComposableNextLink(
  { to, ...props },
  ref
) {
  return <NextLink href={to} {...props} ref={ref} />
})

/**
 * Combines MUI's Button component (for styling) with Next.js Link for internal client-side navigation.
 */
export const InternalLinkButton = forwardRef<HTMLAnchorElement, InternalLinkButtonProps>(function InternalLinkButton(
  { href, ...props },
  ref
) {
  return <Button component={ComposableNextLink} {...props} to={href} ref={ref} />
})
